export default __webpack_public_path__ + "static/media/TargetIcon.c307a7b2.svg";